import React, {
  Component,
  useState,
  useRef,
  useCallback,
  useEffect,
} from 'react'

import {
  Editor,
  EditorState,
  convertFromHTML,
  ContentState,
  convertToRaw,
  convertFromRaw,
} from 'draft-js'
import { useDispatch } from 'react-redux'
import {
  onChangeReply,
  onChange as onChangeComment,
} from 'store/Comments/actions'

import { onChange as onChangeDiscussion } from 'store/Discussion/actions'

const parseContent = (content) => {
  switch (true) {
    case typeof content === 'string':
      const fromHtml = convertFromHTML(content)

      return ContentState.createFromBlockArray(
        fromHtml.contentBlocks,
        fromHtml.entityMap
      )
      break
    case typeof content === 'object' &&
      content !== null &&
      Object.keys(content).length !== 0:
      return convertFromRaw(content)
      break
    default:
      return null
  }
}

export const TextEditor = (props) => {
  const dispatch = useDispatch()
  const content = parseContent(props.content)
  const [editorState, setEditorState] = useState(
    content ? EditorState.createWithContent(content) : EditorState.createEmpty()
  )

  const editorRef = useRef(null)

  const onChange = (newEditorState) => {
    setEditorState(newEditorState)

    if (props.onChange === 'onChangeReply') {
      dispatch(
        onChangeReply(
          props.commentId,
          props.changeProperty || 'data',
          convertToRaw(newEditorState.getCurrentContent())
        )
      )
      dispatch(
        onChangeReply(
          props.commentId,
          'text',
          newEditorState.getCurrentContent().getPlainText()
        )
      )
    } else if (props.onChange === 'onChangeDiscussion') {
      dispatch(
        onChangeDiscussion(
          props.changeProperty || 'data',
          convertToRaw(newEditorState.getCurrentContent())
        )
      )
      dispatch(
        onChangeDiscussion(
          'text',
          newEditorState.getCurrentContent().getPlainText()
        )
      )
    } else {
      dispatch(
        onChangeComment(
          props.changeProperty || 'data',
          convertToRaw(newEditorState.getCurrentContent())
        )
      )
      dispatch(
        onChangeComment(
          'text',
          newEditorState.getCurrentContent().getPlainText()
        )
      )
    }
  }

  useEffect(() => {
    if (props.autoFocus && editorRef.current) {
      editorRef.current.focus()
    }
  }, [props.autoFocus])

  return (
    <Editor
      ref={editorRef}
      editorState={editorState}
      onChange={onChange}
      readOnly={props.readOnly}
      placeholder={props.placeholder || ''}
    />
  )
}

export class Read extends Component {
  constructor(props) {
    super(props)

    this.state = {
      editorState: EditorState.createEmpty(),
    }
  }

  createEditor(props) {
    const content = parseContent(props.content)

    this.setState({
      editorState: content
        ? EditorState.createWithContent(content)
        : EditorState.createEmpty(),
    })
  }

  componentWillReceiveProps(nextProps) {
    this.createEditor(nextProps)
  }

  componentDidMount() {
    this.createEditor(this.props)
  }

  render() {
    return <Editor editorState={this.state.editorState} readOnly={true} />
  }
}

export class TextOnly extends Component {
  constructor(props) {
    super(props)

    this.state = {
      editorState: EditorState.createEmpty(),
    }
  }

  createEditor(props) {
    const content = parseContent(props.content)

    this.setState({
      editorState: content
        ? EditorState.createWithContent(content)
        : EditorState.createEmpty(),
    })
  }

  componentWillReceiveProps(nextProps) {
    this.createEditor(nextProps)
  }

  componentDidMount() {
    this.createEditor(this.props)
  }

  render() {
    return (
      this.state.editorState &&
      this.state.editorState.getCurrentContent().getPlainText()
    )
  }
}
